import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Traduções em português (padrão)
const resources = {
  pt: {
    translation: {
      'views.layouts.home.today_consumption': 'Seu consumo hoje',
      'views.layouts.home.until_now': 'Até o momento',
      'views.layouts.home.until_now_consumption': 'Seu consumo até o momento',
      'views.layouts.home.daily_average': 'Média de consumo diário',
      'views.layouts.home.monthly_average': 'Média de consumo mensal',
      'views.layouts.home.consumption_preview': 'Previsão de consumo para esse período',
      'views.layouts.home.monthly_consumption': 'Consumo mensal',
      'views.layouts.home.monthly_consumption_subtitle': 'Acompanhe seu consumo dos períodos anteriores abaixo.',
      'views.layouts.home.messages_title': 'Informações importantes',
      'views.layouts.home.messages_info': 'Veja algumas mensagens importantes para você.',
      'views.layouts.home.many_days_to_closure_prefix': 'Faltam',
      'views.layouts.home.many_days_to_closure_suffix': 'dias para o fechamento',
      'views.layouts.home.one_day_to_closure_prefix': 'Falta',
      'views.layouts.home.one_day_to_closure_suffix': 'dia para o fechamento',
      'views.layouts.home.today_closure_today': 'Hoje',
      'views.layouts.home.today_closure_suffix': 'é o dia do fechamento',
      'views.layouts.home.message_goal': 'da meta definida para este período!',
      'views.layouts.home.message_period': 'da média de consumo dos últimos 6 meses!',
      'views.layouts.home.congratulations': 'Parabéns!',
      'views.layouts.home.attention': 'Atenção!',
      'views.layouts.home.warning': 'Cuidado!',
      'views.layouts.home.low_consumption': 'Seu consumo está abaixo',
      'views.layouts.home.mid_consumption': 'Seu consumo está próximo',
      'views.layouts.home.high_consumption': 'Seu consumo está acima',
      'views.layouts.breadcrumb.period_start': 'Início do Período',
      'views.consumption.water.cold': 'Fria',
      'views.consumption.water.hot': 'Quente',
      'views.consumption.units.liters': 'L',
      'views.general.charts.type_water': 'Água',
      'views.general.charts.type_gas': 'Gás',
      'views.general.charts.type_energy': 'Energia',
      'views.application.greetings': 'Seja Bem-Vindo',
      'views.application.exit': 'Sair',
      // Registrations (Edit Profile)
      'views.devise.registrations.adjustments': 'Ajustes',
      'views.devise.registrations.title': 'Perfil do condômino',
      'views.devise.registrations.subtitle': 'Aqui você pode alterar os dados do seu perfil e sua senha.',
      'views.devise.registrations.change_profile': 'Altere os dados do seu perfil',
      'views.devise.registrations.email': 'Email',
      'views.devise.registrations.name': 'Nome',
      'views.devise.registrations.last_name': 'Sobrenome',
      'views.devise.registrations.cellphone': 'Celular',
      'views.devise.registrations.inform_password': 'Por questões de segurança, informe sua senha para confirmar alteração',
      'views.devise.registrations.password': 'Senha atual',
      'views.devise.registrations.submit_profile': 'Alterar perfil',
      'views.devise.registrations.profile_updated': 'Perfil atualizado com sucesso',
      'views.devise.registrations.password_updated': 'Senha alterada com sucesso',
      'views.devise.registrations.update_failed': 'Não foi possível realizar a atualização',
      'views.devise.registrations.change_password': 'Altere sua senha',
      'views.devise.registrations.new_password': 'Nova senha',
      'views.devise.registrations.confirm_password': 'Confirme a senha',
      'views.devise.registrations.submit_password': 'Alterar senha',
      'views.devise.registrations.manage_dependent': 'Gerencie seus dependentes',
      'views.devise.registrations.add_dependent': 'Adicionar Membro',
      'views.devise.registrations.save_dependent': 'Salvar Membro',
      'views.devise.registrations.exclude': 'excluir',
      'views.devise.registrations.dependent_added': 'Membro adicionado. Ele receberá um e-mail para confirmar o acesso.',
      'views.devise.registrations.pending_confirmation': 'Aguardando confirmação',
      // Report page
      'views.consumption.report.title': 'Relatórios',
      // Common
      'common.error': 'Erro',
      'common.success': 'Sucesso!',
      'common.retry': 'Tentar novamente',
      // Consumption / errors
      'views.consumption.error_loading': 'Não foi possível carregar os dados.',
      // Goal
      'views.layouts.goal.config': 'Configuração de meta',
      'views.consumption.goal.title': 'Sua meta',
      'views.consumption.goal.success_title': 'Sucesso!',
      'views.consumption.goal.configuration_saved': 'Configuração salva com sucesso.',
      'views.consumption.goal.saving': 'Salvando...',
      'views.consumption.goal.message': 'Este valor é apenas uma projeção baseado no custo médio por m³ dos últimos 3 meses. O valor do m³ varia de acordo com o consumo total do condomínio.',
      'views.consumption.goal.message_gas': 'Este valor é apenas uma projeção baseado no custo médio por m³ dos últimos 3 meses. O valor por m³ varia de acordo com o consumo total do condomínio.',
      // Report details
      'views.consumption.report.details': 'Ver detalhes',
      'views.consumption.report.close': 'X',
      'views.consumption.report.period': 'Período',
      'views.consumption.report.to': 'a',
      'views.consumption.report.daily_average': 'Média diária',
      'views.consumption.report.daily_consumption': 'Consumo diário do período corrente',
      'views.consumption.report.consumption_goal': 'Consumo em relação à meta',
      'views.consumption.report.consumption_average': 'Consumo em relação à média',
      'views.consumption.report.total_consumption': 'Consumo total',
      'views.consumption.report.hint': '* Dias com leituras estimadas',
      'views.consumption.report.last_readings': 'Últimas contas - Cálculo mensal',
      'views.consumption.report.monthly_usage_report': 'Relatório de consumo dos meses anteriores',
      // Charts
      'views.general.charts.checked_days': 'Dias Aferidos',
      'views.general.charts.checked_months': 'Meses Aferidos',
      'views.general.charts.consumption_in': 'Consumo em',
      'views.general.charts.liters': 'Litros',
      'views.general.charts.type_cold_water': 'Água-Fria',
      'views.general.charts.type_hot_water': 'Água-Quente',
      'views.general.charts.type_mineral_water': 'Água Mineral',
      // Common (extra)
      'common.loading': 'Carregando...',
      // Menu / general
      'views.layouts.menu.home': 'Home',
      'views.layouts.menu.open_menu': 'Abrir menu',
      'views.layouts.menu.close_menu': 'Fechar menu',
      'views.general.connection_error': 'Erro de conexão.',
      // Sessions
      'views.devise.sessions.invalid': 'Usuário ou senha inválidos',
      // Empty state (no consumption data)
      'views.consumption.no_data.title': 'Sem dados de consumo',
      'views.consumption.no_data.text': 'Ainda não encontramos um medidor de {{meter}} cadastrado para esta unidade.',
      // Admin
      'views.admin.load_error': 'Erro ao carregar condomínios',
      'views.admin.choose_condominium': 'Escolha um dos condomínios abaixo:',
      'views.admin.no_condominium_access': 'Você não tem acesso à nenhum condomínio. Peça acesso ao condomínio desejado através do e-mail',
      'views.admin.residence_users.load_error': 'Erro ao carregar residências',
      'views.admin.residence_users.save_error': 'Erro ao salvar email',
      'views.admin.residence_users.title': 'Cadastro de moradores',
      'views.admin.residence_users.intro': 'Para cadastrar basta preencher o campo email e pressionar ENTER. Em poucos segundos a planilha será salva automaticamente. Após a confirmação do morador e cadastramento da senha os campos nome e sobrenome estarão preenchidos.',
      'views.admin.residence_users.th_block': 'Bloco',
      'views.admin.residence_users.th_unit': 'Unidade',
      'views.admin.residence_users.th_status': 'Status',
      'views.admin.residence_users.click_to_edit': 'Clique para editar',
      'views.admin.residence_users.status_confirmed': 'Confirmado',
      'views.admin.residence_users.status_pending': 'Pendente',
      'views.admin.residence_users.status_not_registered': 'Não cadastrado',
      'views.admin.residence_users.none_found': 'Nenhuma residência encontrada',
      // Common (extra 2)
      'common.close': 'Fechar',
      'common.wait': 'Aguarde...',
      'common.back': 'Voltar',
      // Login
      'views.login.email_placeholder': 'E-mail',
      'views.login.password_placeholder': 'Senha',
      'views.login.signing_in': 'Entrando...',
      'views.login.sign_in': 'Entrar',
      'views.login.or': 'ou',
      'views.login.oauth_start_error': 'Não foi possível iniciar o login com {{provider}}.',
      'views.login.sign_in_with_facebook': 'Entrar com o Facebook',
      'views.login.sign_in_with_google': 'Entrar com o Google',
      'views.login.sign_in_with_apple': 'Entrar com a Apple',
      'views.login.create_account': 'Criar conta',
      'views.login.first_access': 'Primeiro acesso',
      'views.login.forgot_password': 'Esqueceu sua senha?',
      // Registration - steps meta
      'views.registration.steps.address.title': 'Crie sua conta',
      'views.registration.steps.address.subtitle': 'Informe o CEP e o número do seu endereço para localizarmos sua unidade.',
      'views.registration.steps.unit.title': 'Confirme sua unidade',
      'views.registration.steps.unit.subtitle': 'Selecione sua unidade ou comprove a titularidade da ligação.',
      'views.registration.steps.user_data.title': 'Seus dados',
      'views.registration.steps.user_data.subtitle': 'Preencha seus dados de acesso.',
      'views.registration.steps.document.title': 'Comprovante de endereço',
      'views.registration.steps.document.subtitle': 'Envie um documento que comprove o endereço informado.',
      'views.registration.steps.code.title': 'Confirmação',
      'views.registration.steps.success.title': 'Pronto!',
      // Registration - indicator
      'views.registration.indicator.address': 'Endereço',
      'views.registration.indicator.unit': 'Unidade',
      'views.registration.indicator.user_data': 'Seus dados',
      'views.registration.indicator.document': 'Documento',
      'views.registration.indicator.code': 'Confirmação',
      // Registration - shared
      'views.registration.have_account': 'Já tem conta?',
      'views.registration.progress_aria': 'Progresso do cadastro',
      'views.registration.sending': 'Enviando...',
      'views.registration.captcha_required': 'Confirme que você não é um robô.',
      'views.registration.captcha_dev_mode': 'Verificação anti-robô em modo de desenvolvimento (captcha desativado).',
      'views.registration.alert.success_title': 'Tudo certo!',
      'views.registration.alert.info_title': 'Aviso',
      // Registration - password strength
      'views.registration.password_strength.0': 'Muito fraca',
      'views.registration.password_strength.1': 'Fraca',
      'views.registration.password_strength.2': 'Razoável',
      'views.registration.password_strength.3': 'Boa',
      'views.registration.password_strength.4': 'Forte',
      'views.registration.hide_password': 'Ocultar senha',
      'views.registration.show_password': 'Mostrar senha',
      'views.registration.strength_prefix': 'Força:',
      // Registration - address step
      'views.registration.address.invalid_zip': 'Informe um CEP válido (8 dígitos).',
      'views.registration.address.invalid_number': 'Informe o número do endereço.',
      'views.registration.address.not_found': 'Não encontramos um endereço com medidor Laager para esse CEP e número. Confira os dados.',
      'views.registration.address.lookup_error': 'Não foi possível consultar o endereço. Tente novamente.',
      'views.registration.address.zip_label': 'CEP',
      'views.registration.address.number_label': 'Número',
      'views.registration.address.number_placeholder': 'Ex.: 123',
      'views.registration.address.submit': 'Buscar endereço',
      'views.registration.address.submitting': 'Buscando...',
      // Registration - unit step
      'views.registration.unit.address_found': 'Endereço encontrado',
      'views.registration.unit.select_tower_error': 'Selecione a torre/bloco.',
      'views.registration.unit.select_unit_error': 'Selecione a sua unidade.',
      'views.registration.unit.rgi_error': 'Informe o RGI da sua ligação.',
      'views.registration.unit.ownership_error': 'Informe o código de titularidade.',
      'views.registration.unit.validate_utility_error': 'Não conseguimos validar o RGI e o código de titularidade informados.',
      'views.registration.unit.validate_unit_error': 'Não conseguimos validar a unidade selecionada.',
      'views.registration.unit.validate_generic_error': 'Não foi possível validar. Tente novamente.',
      'views.registration.unit.tower_label': 'Torre / Bloco',
      'views.registration.unit.select_placeholder': 'Selecione...',
      'views.registration.unit.choose_tower_first': 'Escolha a torre primeiro',
      'views.registration.unit.rgi_placeholder': 'Número da sua ligação (RGI)',
      'views.registration.unit.rgi_hint': 'Encontrado na sua conta de água/gás.',
      'views.registration.unit.ownership_label': 'Código de titularidade (CPF ou CNPJ)',
      'views.registration.unit.ownership_placeholder': 'Código enviado pela concessionária',
      'views.registration.unit.prove_with_document': 'Comprovar titularidade enviando um documento',
      'views.registration.unit.already_registered': 'Não é possível continuar o cadastro para a unidade selecionada, pois ela já está cadastrada para o(a) Sr(a) {{name}} ({{email}}). É possível solicitar a pessoa titular que adicione você como dependente do cadastro dela.',
      'views.registration.unit.already_registered_no_owner': 'Não é possível continuar: esta unidade já possui um cadastro ativo.',
      'views.registration.unit.submit': 'Validar unidade',
      'views.registration.unit.submitting': 'Validando...',
      // Registration - user data step
      'views.registration.user_data.first_name_error': 'Informe seu nome.',
      'views.registration.user_data.last_name_error': 'Informe seu sobrenome.',
      'views.registration.user_data.email_error': 'Informe um e-mail válido.',
      'views.registration.user_data.phone_error': 'Informe um celular válido com DDD.',
      'views.registration.user_data.password_error': 'A senha deve ter ao menos 8 caracteres.',
      'views.registration.user_data.confirm_error': 'As senhas não conferem.',
      'views.registration.user_data.terms_error': 'É necessário aceitar os termos para continuar.',
      'views.registration.user_data.email_taken': 'Este e-mail já possui cadastro. Tente entrar ou recuperar a senha.',
      'views.registration.user_data.email_already_registered': 'Este e-mail já está cadastrado. Clique em “Entrar” para acessar sua conta. Caso não se lembre da senha, clique em “Recuperar senha”.',
      'views.registration.user_data.submit_error': 'Não foi possível concluir o cadastro. Tente novamente.',
      'views.registration.user_data.email_hint': 'Enviaremos o código de confirmação para este e-mail.',
      'views.registration.user_data.password_hint': 'Use ao menos 8 caracteres, com letras e números.',
      'views.registration.user_data.terms_prefix': 'Li e concordo com a',
      'views.registration.user_data.privacy_policy': 'Política de Privacidade',
      'views.registration.user_data.terms_suffix': 'e autorizo o tratamento dos meus dados (LGPD).',
      'views.registration.user_data.submit': 'Continuar',
      // Registration - document step
      'views.registration.document.invalid_format': 'Formato inválido. Envie JPG, PNG, WEBP ou PDF.',
      'views.registration.document.too_large': 'Arquivo muito grande. O limite é de 8 MB.',
      'views.registration.document.invalid_file': 'Arquivo inválido.',
      'views.registration.document.select_error': 'Selecione um documento para enviar.',
      'views.registration.document.upload_error': 'Não foi possível enviar o documento. Tente novamente.',
      'views.registration.document.info': 'O documento deve estar em seu nome, apresentar seu nome completo e mostrar o mesmo endereço informado no cadastro.\n\nVocê pode enviar, por exemplo, uma conta de água, energia, internet ou telefone. O arquivo deve estar completo e legível.\n\nA verificação é automática. Em alguns casos, o documento poderá ser encaminhado para análise manual pela administração.',
      'views.registration.document.select_aria': 'Selecionar documento',
      'views.registration.document.drop_hint': 'Arraste o arquivo aqui ou clique para selecionar',
      'views.registration.document.file_types': 'JPG, PNG, WEBP ou PDF · até 8 MB',
      'views.registration.document.preview_alt': 'Pré-visualização do documento',
      'views.registration.document.remove_aria': 'Remover documento',
      'views.registration.document.submit': 'Enviar documento',
      // Registration - code step
      'views.registration.code.incomplete': 'Digite os 6 dígitos do código.',
      'views.registration.code.confirm_error': 'Não foi possível confirmar o código.',
      'views.registration.code.pending_title': 'Código confirmado!',
      'views.registration.code.pending_text': 'Seu documento está em análise. Assim que a titularidade for aprovada, você receberá um aviso por e-mail e poderá acessar sua conta.',
      'views.registration.code.pending_flash': 'Seu documento está em análise. Você receberá um e-mail assim que a titularidade for aprovada e poderá acessar sua conta.',
      'views.registration.code.understood': 'Entendi',
      'views.registration.code.intro': 'Enviamos um código de 6 dígitos para <1>{{email}}</1>. Digite-o abaixo para confirmar sua conta.',
      'views.registration.code.group_aria': 'Código de confirmação',
      'views.registration.code.digit_aria': 'Dígito {{n}}',
      'views.registration.code.spam_hint': 'Verifique também a caixa de spam. O código expira em alguns minutos.',
      'views.registration.code.submit': 'Confirmar cadastro',
      'views.registration.code.submitting': 'Confirmando...',
      // Registration - success step
      'views.registration.success.title': 'Cadastro concluído!',
      'views.registration.success.text': 'Sua conta foi confirmada com sucesso. Agora você já pode acessar e acompanhar o consumo da sua unidade.',
      'views.registration.success.access_account': 'Acessar minha conta',
      // Common (back to login)
      'common.back_to_login': 'Voltar para o login',
      // Forgot password
      'views.forgot_password.success': 'E-mail de recuperação de senha enviado com sucesso.',
      'views.forgot_password.error': 'Erro ao enviar email de recuperação',
      'views.forgot_password.title': 'Esqueci a senha',
      'views.forgot_password.subtitle': 'Informe seu e-mail cadastrado para receber o link de redefinição.',
      'views.forgot_password.email_placeholder': 'Digite seu email para envio de token',
      'views.forgot_password.submit': 'Enviar',
      // First access
      'views.first_access.title': 'Primeiro Acesso',
      'views.first_access.lgpd_label': 'LGPD:',
      'views.first_access.lgpd_text': 'Por questões de segurança e proteção de dados, precisamos confirmar sua identidade antes de liberar o acesso. Serão solicitados documentos que comprovem sua identidade e vínculo com a unidade.',
      'views.first_access.create_now': 'Criar minha conta agora',
      'views.first_access.create_now_hint': 'Faça seu cadastro em poucos passos, direto por aqui.',
      'views.first_access.prefer_support': 'Prefere atendimento? Fale conosco',
      'views.first_access.condo_title': 'Medidor com dispositivo Laager no seu condomínio?',
      'views.first_access.condo_text': 'Entre em contato com sua administradora ou com nosso suporte.',
      'views.first_access.city_title': 'Medidor com dispositivo Laager na sua cidade?',
      'views.first_access.city_text': 'Já tem um produto Laager instalado na sua residência? Procure a agência de atendimento do serviço da concessionária da sua cidade e solicite o cadastro.',
      'views.first_access.support_title': 'Atendimento Laager',
      'views.first_access.phone_label': 'Telefone',
      // Account confirmation
      'views.account_confirmation.title': 'Concluir cadastro',
      'views.account_confirmation.invalid_title': 'Link inválido',
      'views.account_confirmation.invalid_text': 'Este link de confirmação é inválido ou já foi utilizado. Solicite um novo convite ou faça login se já concluiu seu cadastro.',
      'views.account_confirmation.go_to_login': 'Ir para o login',
      'views.account_confirmation.success': 'Cadastro concluído com sucesso. Faça login para continuar.',
      'views.account_confirmation.subtitle_with_email': 'Finalize o cadastro de {{email}} definindo seus dados e uma senha.',
      'views.account_confirmation.subtitle_default': 'Defina seus dados e uma senha para concluir o cadastro.',
      'views.account_confirmation.submit': 'Concluir cadastro',
      'views.account_confirmation.social.error': 'Não foi possível iniciar a confirmação. Tente novamente ou use o formulário abaixo.',
      'views.account_confirmation.social.intro': 'Confirme com um clique usando sua conta Google ou Facebook — sem precisar criar uma senha.',
      'views.account_confirmation.social.redirecting': 'Redirecionando...',
      'views.account_confirmation.social.confirm_google': 'Confirmar com o Google',
      'views.account_confirmation.social.confirm_facebook': 'Confirmar com o Facebook',
      // Landing
      'views.landing.hero_title': 'Inovação para desafios modernos',
      'views.landing.hero_text': '"Somos referência na América Latina em inovação e desenvolvimento de soluções para eficiência energética e hídrica com utilização de sistemas e comunicação remota (IoT) para automação de medidores de água, gás e energia."',
      'views.landing.hero_cta': 'Confira seu consumo agora',
      'views.landing.section2_title': 'Soluções inovadoras para o seu dia a dia',
      'views.landing.section2_text': 'Laager Tecnologias Renováveis, sediada em São Paulo, SP, dedica-se a transformar a forma como gerenciamos recursos hídricos, gasosos e elétricos com nosso aplicativo inovador de monitoramento de consumo. Nossa missão é capacitar indivíduos e empresas a otimizar o uso da água, do gás e da energia, promovendo sustentabilidade e eficiência.',
      'views.landing.badge': 'Poupe Recursos',
      'views.landing.water_title': 'Monitoramento de Água',
      'views.landing.water_text': 'Acompanhe seu consumo de água em tempo real e identifique padrões de uso.',
      'views.landing.gas_title': 'Monitoramento de Gás',
      'views.landing.gas_text': 'Controle seu consumo de gás e receba alertas de consumo atípico.',
      'views.landing.modal_title': 'Baixe o App',
      'views.landing.choose_platform': 'Escolha sua plataforma:',
      'views.landing.browser_access': 'Ou acesse pelo navegador:',
      'views.landing.copyright': '© 2024 Laager Tecnologias Sustentáveis. Todos os direitos reservados.',
      // Errors
      'views.errors.oops': 'Ops!',
      'views.errors.not_found': 'Não conseguimos localizar a página desejada :(',
      'views.errors.forbidden': 'Não conseguimos localizar a página desejada ou você não tem acesso :(',
      'views.errors.server_error_title': 'Falha ao processar',
      'views.errors.server_error_text': 'Aconteceu um erro que não prevíamos. Desculpe-nos. Já fomos notificados que este problema ocorreu e em breve o solucionaremos.',
      'views.errors.unavailable_title': 'Serviço indisponível',
      'views.errors.unavailable_text': 'No momento o serviço de leituras não está disponível. Tente mais tarde',
      // Privacy policy
      'views.privacy.s1_title': '1. Informações Gerais',
      'views.privacy.s1_p1': 'A presente Política de Privacidade contém informações a respeito do modo como tratamos, total ou parcialmente, de forma automatizada ou não, os dados pessoais dos usuários que acessam nosso site. Seu objetivo é esclarecer os interessados acerca dos tipos de dados que são coletados, dos motivos da coleta e da forma como o usuário poderá atualizar, gerenciar ou excluir estas informações.',
      'views.privacy.s1_p2': 'Esta Política de Privacidade foi elaborada em conformidade com a Lei Federal n. 12.965 de 23 de abril de 2014 (Marco Civil da Internet), com a Lei Federal n. 13.709, de 14 de agosto de 2018 (Lei de Proteção de Dados Pessoais) e com o Regulamento UE n. 2016/679 de 27 de abril de 2016 (Regulamento Geral Europeu de Proteção de Dados Pessoais - RGDP).',
      'views.privacy.s1_p3': 'Esta Política de Privacidade poderá ser atualizada em decorrência de eventual atualização normativa, razão pela qual se convida o usuário a consultar periodicamente esta seção.',
      'views.privacy.s2_title': '2. Direitos do usuário',
      'views.privacy.s2_intro': 'O site se compromete a cumprir as normas previstas no RGPD, em respeito aos seguintes princípios:',
      'views.privacy.s2_principle_1': 'Os dados pessoais do usuário serão processados de forma lícita, leal e transparente (licitude, lealdade e transparência);',
      'views.privacy.s2_principle_2': 'Os dados pessoais do usuário serão coletados apenas para finalidades determinadas, explícitas e legítimas;',
      'views.privacy.s2_principle_3': 'Os dados pessoais do usuário serão coletados de forma adequada, pertinente e limitada às necessidades do objetivo;',
      'views.privacy.s2_principle_4': 'Os dados pessoais do usuário serão exatos e atualizados sempre que necessário;',
      'views.privacy.s2_principle_5': 'Os dados pessoais do usuário serão conservados apenas durante o período necessário;',
      'views.privacy.s2_principle_6': 'Os dados pessoais do usuário serão tratados de forma segura.',
      'views.privacy.s2_rights_intro': 'O usuário do site possui os seguintes direitos:',
      'views.privacy.s2_right_1_label': 'Direito de confirmação e acesso:',
      'views.privacy.s2_right_1_text': 'obter confirmação de que os dados pessoais são ou não objeto de tratamento;',
      'views.privacy.s2_right_2_label': 'Direito de retificação:',
      'views.privacy.s2_right_2_text': 'obter a retificação dos dados pessoais inexatos;',
      'views.privacy.s2_right_3_label': 'Direito à eliminação dos dados:',
      'views.privacy.s2_right_3_text': 'ter seus dados apagados do site;',
      'views.privacy.s2_right_4_label': 'Direito à limitação do tratamento:',
      'views.privacy.s2_right_4_text': 'limitar o tratamento de seus dados pessoais;',
      'views.privacy.s2_right_5_label': 'Direito de oposição:',
      'views.privacy.s2_right_5_text': 'se opor ao tratamento dos dados pessoais;',
      'views.privacy.s2_right_6_label': 'Direito de portabilidade:',
      'views.privacy.s2_right_6_text': 'receber os dados pessoais em formato estruturado;',
      'views.privacy.s2_right_7_label': 'Direito de não ser submetido a decisões automatizadas.',
      'views.privacy.s2_exercise': 'O usuário poderá exercer os seus direitos por meio de comunicação escrita enviada ao e-mail:',
      'views.privacy.s3_title': '3. Dever de não fornecer dados de terceiros',
      'views.privacy.s3_p1': 'Durante a utilização do site, a fim de resguardar e de proteger os direitos de terceiros, o usuário do site deverá fornecer somente seus dados pessoais, e não os de terceiros.',
      'views.privacy.s4_title': '4. Informações coletadas',
      'views.privacy.s4_p1': 'A coleta de dados dos usuários se dará em conformidade com o disposto nesta Política de Privacidade e dependerá do consentimento do usuário.',
      'views.privacy.s41_title': '4.1. Tipos de dados coletados',
      'views.privacy.s41_intro': 'A utilização de determinadas funcionalidades do site dependerá de cadastro, sendo que os seguintes dados do usuário serão coletados e armazenados:',
      'views.privacy.s41_data_email': 'Endereço de e-mail',
      'views.privacy.s41_data_address': 'Endereço postal',
      'views.privacy.s41_data_phone': 'Número de telefone',
      'views.privacy.s5_title': '5. Compartilhamento de dados pessoais',
      'views.privacy.s5_p1': 'O site não compartilha dados pessoais com terceiros, exceto quando necessário para o funcionamento do serviço ou exigido por lei.',
      'views.privacy.s6_title': '6. Segurança',
      'views.privacy.s6_p1': 'O site se compromete a aplicar as medidas técnicas e organizativas aptas a proteger os dados pessoais de acessos não autorizados e de situações de destruição, perda, alteração, comunicação ou difusão de tais dados.',
      'views.privacy.s7_title': '7. Contato',
      'views.privacy.s7_p1': 'Em caso de dúvidas sobre esta Política de Privacidade ou sobre os dados pessoais que tratamos, entre em contato:',
    }
  },
  en: {
    translation: {
      'views.layouts.home.today_consumption': 'Today\'s Consumption',
      'views.layouts.home.until_now': 'Until Now',
      'views.layouts.home.until_now_consumption': 'Consumption Until Now',
      'views.layouts.home.daily_average': 'Daily Average',
      'views.layouts.home.monthly_average': 'Monthly Average',
      'views.layouts.home.consumption_preview': 'Consumption Forecast',
      'views.layouts.home.monthly_consumption': 'Monthly Consumption',
      'views.layouts.home.monthly_consumption_subtitle': 'Last months consumption',
      'views.layouts.home.monthly_consumption_messages': 'Messages about your consumption',
      'views.layouts.home.many_days_to_closure_prefix': '',
      'views.layouts.home.many_days_to_closure_suffix': 'days to statement',
      'views.layouts.home.one_day_to_closure_prefix': '',
      'views.layouts.home.one_day_to_closure_suffix': 'day to statement',
      'views.layouts.home.today_closure_today': 'Today',
      'views.layouts.home.today_closure_suffix': 'is the statement day',
      'views.layouts.home.message_goal': 'for your defined goal',
      'views.layouts.home.message_period': 'for the period average',
      'views.layouts.home.congratulations': 'Congratulations!',
      'views.layouts.home.attention': 'Attention!',
      'views.layouts.home.warning': 'Warning!',
      'views.layouts.home.low_consumption': 'Your consumption is below',
      'views.layouts.home.mid_consumption': 'Your consumption is within',
      'views.layouts.home.high_consumption': 'Your consumption is above',
      'views.layouts.breadcrumb.period_start': 'Period start',
      'views.consumption.water.cold': 'Cold',
      'views.consumption.water.hot': 'Hot',
      'views.consumption.units.liters': 'L',
      'views.general.charts.type_water': 'Water',
      'views.general.charts.type_gas': 'Gas',
      'views.general.charts.type_energy': 'Energy',
      'views.application.greetings': 'Welcome',
      'views.application.exit': 'Exit',
      // Registrations (Edit Profile)
      'views.devise.registrations.adjustments': 'Settings',
      'views.devise.registrations.title': 'User Profile',
      'views.devise.registrations.subtitle': 'Here you can change your profile data and password.',
      'views.devise.registrations.change_profile': 'Edit your profile',
      'views.devise.registrations.email': 'Email',
      'views.devise.registrations.name': 'Name',
      'views.devise.registrations.last_name': 'Last Name',
      'views.devise.registrations.cellphone': 'Phone',
      'views.devise.registrations.inform_password': 'For security reasons, enter your password to confirm the change',
      'views.devise.registrations.password': 'Current Password',
      'views.devise.registrations.submit_profile': 'Update profile',
      'views.devise.registrations.profile_updated': 'Profile updated successfully',
      'views.devise.registrations.password_updated': 'Password changed successfully',
      'views.devise.registrations.update_failed': 'Could not update',
      'views.devise.registrations.change_password': 'Change your password',
      'views.devise.registrations.new_password': 'New password',
      'views.devise.registrations.confirm_password': 'Confirm password',
      'views.devise.registrations.submit_password': 'Update password',
      'views.devise.registrations.manage_dependent': 'Manage your dependents',
      'views.devise.registrations.add_dependent': 'Add Member',
      'views.devise.registrations.save_dependent': 'Save Member',
      'views.devise.registrations.exclude': 'delete',
      'views.devise.registrations.dependent_added': 'Member added. They will receive an email to confirm access.',
      'views.devise.registrations.pending_confirmation': 'Awaiting confirmation',
      // Report page
      'views.consumption.report.title': 'Reports',
      // Common
      'common.error': 'Error',
      'common.success': 'Success!',
      'common.retry': 'Try again',
      // Consumption / errors
      'views.consumption.error_loading': 'Could not load the data.',
      // Goal
      'views.layouts.goal.config': 'Goal settings',
      'views.consumption.goal.title': 'Your goal',
      'views.consumption.goal.success_title': 'Success!',
      'views.consumption.goal.configuration_saved': 'Settings saved successfully.',
      'views.consumption.goal.saving': 'Saving...',
      'views.consumption.goal.message': 'This value is only a projection based on the average cost per m³ over the last 3 months. The price per m³ varies according to the total consumption of the building.',
      'views.consumption.goal.message_gas': 'This value is only a projection based on the average cost per m³ over the last 3 months. The price per m³ varies according to the total consumption of the building.',
      // Report details
      'views.consumption.report.details': 'View details',
      'views.consumption.report.close': 'X',
      'views.consumption.report.period': 'Period',
      'views.consumption.report.to': 'to',
      'views.consumption.report.daily_average': 'Daily average',
      'views.consumption.report.daily_consumption': 'Daily consumption for the current period',
      'views.consumption.report.consumption_goal': 'Consumption vs. goal',
      'views.consumption.report.consumption_average': 'Consumption vs. average',
      'views.consumption.report.total_consumption': 'Total consumption',
      'views.consumption.report.hint': '* Days with estimated readings',
      'views.consumption.report.last_readings': 'Latest bills - Monthly calculation',
      'views.consumption.report.monthly_usage_report': 'Consumption report for previous months',
      // Charts
      'views.general.charts.checked_days': 'Measured Days',
      'views.general.charts.checked_months': 'Measured Months',
      'views.general.charts.consumption_in': 'Consumption in',
      'views.general.charts.liters': 'Liters',
      'views.general.charts.type_cold_water': 'Cold Water',
      'views.general.charts.type_hot_water': 'Hot Water',
      'views.general.charts.type_mineral_water': 'Mineral Water',
      // Common (extra)
      'common.loading': 'Loading...',
      // Menu / general
      'views.layouts.menu.home': 'Home',
      'views.layouts.menu.open_menu': 'Open menu',
      'views.layouts.menu.close_menu': 'Close menu',
      'views.general.connection_error': 'Connection error.',
      // Sessions
      'views.devise.sessions.invalid': 'Invalid username or password',
      // Empty state (no consumption data)
      'views.consumption.no_data.title': 'No consumption data',
      'views.consumption.no_data.text': 'We haven\'t found a {{meter}} meter registered for this unit yet.',
      // Admin
      'views.admin.load_error': 'Error loading buildings',
      'views.admin.choose_condominium': 'Choose one of the buildings below:',
      'views.admin.no_condominium_access': 'You do not have access to any building. Request access to the desired building through the e-mail',
      'views.admin.residence_users.load_error': 'Error loading residences',
      'views.admin.residence_users.save_error': 'Error saving email',
      'views.admin.residence_users.title': 'Resident registration',
      'views.admin.residence_users.intro': 'To register, just fill in the email field and press ENTER. Within a few seconds the sheet will be saved automatically. After the resident confirms and sets a password, the name and last name fields will be filled in.',
      'views.admin.residence_users.th_block': 'Block',
      'views.admin.residence_users.th_unit': 'Unit',
      'views.admin.residence_users.th_status': 'Status',
      'views.admin.residence_users.click_to_edit': 'Click to edit',
      'views.admin.residence_users.status_confirmed': 'Confirmed',
      'views.admin.residence_users.status_pending': 'Pending',
      'views.admin.residence_users.status_not_registered': 'Not registered',
      'views.admin.residence_users.none_found': 'No residence found',
      // Common (extra 2)
      'common.close': 'Close',
      'common.wait': 'Please wait...',
      'common.back': 'Back',
      // Login
      'views.login.email_placeholder': 'E-mail',
      'views.login.password_placeholder': 'Password',
      'views.login.signing_in': 'Signing in...',
      'views.login.sign_in': 'Sign in',
      'views.login.or': 'or',
      'views.login.oauth_start_error': 'Could not start login with {{provider}}.',
      'views.login.sign_in_with_facebook': 'Sign in with Facebook',
      'views.login.sign_in_with_google': 'Sign in with Google',
      'views.login.sign_in_with_apple': 'Sign in with Apple',
      'views.login.create_account': 'Create account',
      'views.login.first_access': 'First access',
      'views.login.forgot_password': 'Forgot your password?',
      // Registration - steps meta
      'views.registration.steps.address.title': 'Create your account',
      'views.registration.steps.address.subtitle': 'Enter your ZIP code and address number so we can locate your unit.',
      'views.registration.steps.unit.title': 'Confirm your unit',
      'views.registration.steps.unit.subtitle': 'Select your unit or prove ownership of the connection.',
      'views.registration.steps.user_data.title': 'Your details',
      'views.registration.steps.user_data.subtitle': 'Fill in your access details.',
      'views.registration.steps.document.title': 'Verification',
      'views.registration.steps.document.subtitle': 'Send a document proving your ownership.',
      'views.registration.steps.code.title': 'Confirmation',
      'views.registration.steps.success.title': 'Done!',
      // Registration - indicator
      'views.registration.indicator.address': 'Address',
      'views.registration.indicator.unit': 'Unit',
      'views.registration.indicator.user_data': 'Your details',
      'views.registration.indicator.document': 'Document',
      'views.registration.indicator.code': 'Confirmation',
      // Registration - shared
      'views.registration.have_account': 'Already have an account?',
      'views.registration.progress_aria': 'Registration progress',
      'views.registration.sending': 'Sending...',
      'views.registration.captcha_required': 'Confirm that you are not a robot.',
      'views.registration.captcha_dev_mode': 'Anti-bot verification in development mode (captcha disabled).',
      'views.registration.alert.success_title': 'All set!',
      'views.registration.alert.info_title': 'Notice',
      // Registration - password strength
      'views.registration.password_strength.0': 'Very weak',
      'views.registration.password_strength.1': 'Weak',
      'views.registration.password_strength.2': 'Fair',
      'views.registration.password_strength.3': 'Good',
      'views.registration.password_strength.4': 'Strong',
      'views.registration.hide_password': 'Hide password',
      'views.registration.show_password': 'Show password',
      'views.registration.strength_prefix': 'Strength:',
      // Registration - address step
      'views.registration.address.invalid_zip': 'Enter a valid ZIP code (8 digits).',
      'views.registration.address.invalid_number': 'Enter the address number.',
      'views.registration.address.not_found': 'We could not find an address with a Laager meter for this ZIP code and number. Please check the details.',
      'views.registration.address.lookup_error': 'Could not look up the address. Please try again.',
      'views.registration.address.zip_label': 'ZIP code',
      'views.registration.address.number_label': 'Number',
      'views.registration.address.number_placeholder': 'e.g. 123',
      'views.registration.address.submit': 'Search address',
      'views.registration.address.submitting': 'Searching...',
      // Registration - unit step
      'views.registration.unit.address_found': 'Address found',
      'views.registration.unit.select_tower_error': 'Select the tower/block.',
      'views.registration.unit.select_unit_error': 'Select your unit.',
      'views.registration.unit.rgi_error': 'Enter the RGI of your connection.',
      'views.registration.unit.ownership_error': 'Enter the ownership code.',
      'views.registration.unit.validate_utility_error': 'We could not validate the RGI and ownership code provided.',
      'views.registration.unit.validate_unit_error': 'We could not validate the selected unit.',
      'views.registration.unit.validate_generic_error': 'Could not validate. Please try again.',
      'views.registration.unit.tower_label': 'Tower / Block',
      'views.registration.unit.select_placeholder': 'Select...',
      'views.registration.unit.choose_tower_first': 'Choose the tower first',
      'views.registration.unit.rgi_placeholder': 'Your connection number (RGI)',
      'views.registration.unit.rgi_hint': 'Found on your water/gas bill.',
      'views.registration.unit.ownership_label': 'Ownership code',
      'views.registration.unit.ownership_placeholder': 'Code sent by the utility',
      'views.registration.unit.prove_with_document': 'Prove ownership by sending a document',
      'views.registration.unit.already_registered': 'You cannot continue registering the selected unit, as it is already registered to {{name}} ({{email}}).',
      'views.registration.unit.already_registered_no_owner': 'You cannot continue: this unit already has an active registration.',
      'views.registration.unit.submit': 'Validate unit',
      'views.registration.unit.submitting': 'Validating...',
      // Registration - user data step
      'views.registration.user_data.first_name_error': 'Enter your first name.',
      'views.registration.user_data.last_name_error': 'Enter your last name.',
      'views.registration.user_data.email_error': 'Enter a valid e-mail.',
      'views.registration.user_data.phone_error': 'Enter a valid mobile number with area code.',
      'views.registration.user_data.password_error': 'The password must be at least 8 characters.',
      'views.registration.user_data.confirm_error': 'The passwords do not match.',
      'views.registration.user_data.terms_error': 'You must accept the terms to continue.',
      'views.registration.user_data.email_taken': 'This e-mail already has an account. Try signing in or recovering your password.',
      'views.registration.user_data.email_already_registered': 'This e-mail is already registered. Click “Sign in” to access your account. If you don’t remember your password, click “Forgot password”.',
      'views.registration.user_data.submit_error': 'Could not complete the registration. Please try again.',
      'views.registration.user_data.email_hint': 'We will send the confirmation code to this e-mail.',
      'views.registration.user_data.password_hint': 'Use at least 8 characters, with letters and numbers.',
      'views.registration.user_data.terms_prefix': 'I have read and agree to the',
      'views.registration.user_data.privacy_policy': 'Privacy Policy',
      'views.registration.user_data.terms_suffix': 'and authorize the processing of my data (LGPD).',
      'views.registration.user_data.submit': 'Continue',
      // Registration - document step
      'views.registration.document.invalid_format': 'Invalid format. Send JPG, PNG, WEBP or PDF.',
      'views.registration.document.too_large': 'File too large. The limit is 8 MB.',
      'views.registration.document.invalid_file': 'Invalid file.',
      'views.registration.document.select_error': 'Select a document to send.',
      'views.registration.document.upload_error': 'Could not send the document. Please try again.',
      'views.registration.document.info': 'Send a document proving your ownership (e.g. a utility bill, contract or deed). The review is automatic and may require approval from the administration.',
      'views.registration.document.select_aria': 'Select document',
      'views.registration.document.drop_hint': 'Drag the file here or click to select',
      'views.registration.document.file_types': 'JPG, PNG, WEBP or PDF · up to 8 MB',
      'views.registration.document.preview_alt': 'Document preview',
      'views.registration.document.remove_aria': 'Remove document',
      'views.registration.document.submit': 'Send document',
      // Registration - code step
      'views.registration.code.incomplete': 'Enter the 6 digits of the code.',
      'views.registration.code.confirm_error': 'Could not confirm the code.',
      'views.registration.code.pending_title': 'Code confirmed!',
      'views.registration.code.pending_text': 'Your document is under review. As soon as ownership is approved, you will receive an e-mail notification and be able to access your account.',
      'views.registration.code.pending_flash': 'Your document is under review. You will receive an e-mail as soon as ownership is approved and you can access your account.',
      'views.registration.code.understood': 'Got it',
      'views.registration.code.intro': 'We sent a 6-digit code to <1>{{email}}</1>. Enter it below to confirm your account.',
      'views.registration.code.group_aria': 'Confirmation code',
      'views.registration.code.digit_aria': 'Digit {{n}}',
      'views.registration.code.spam_hint': 'Also check your spam folder. The code expires in a few minutes.',
      'views.registration.code.submit': 'Confirm registration',
      'views.registration.code.submitting': 'Confirming...',
      // Registration - success step
      'views.registration.success.title': 'Registration complete!',
      'views.registration.success.text': 'Your account has been successfully confirmed. You can now access and track your unit\'s consumption.',
      'views.registration.success.access_account': 'Access my account',
      // Common (back to login)
      'common.back_to_login': 'Back to login',
      // Forgot password
      'views.forgot_password.success': 'Password recovery e-mail sent successfully.',
      'views.forgot_password.error': 'Error sending recovery e-mail',
      'views.forgot_password.title': 'Forgot password',
      'views.forgot_password.subtitle': 'Enter your registered e-mail to receive the reset link.',
      'views.forgot_password.email_placeholder': 'Enter your e-mail to receive a token',
      'views.forgot_password.submit': 'Send',
      // First access
      'views.first_access.title': 'First Access',
      'views.first_access.lgpd_label': 'LGPD:',
      'views.first_access.lgpd_text': 'For security and data protection reasons, we need to confirm your identity before granting access. Documents proving your identity and connection to the unit will be requested.',
      'views.first_access.create_now': 'Create my account now',
      'views.first_access.create_now_hint': 'Sign up in a few steps, right here.',
      'views.first_access.prefer_support': 'Prefer support? Talk to us',
      'views.first_access.condo_title': 'Meter with a Laager device in your building?',
      'views.first_access.condo_text': 'Contact your property manager or our support.',
      'views.first_access.city_title': 'Meter with a Laager device in your city?',
      'views.first_access.city_text': 'Already have a Laager product installed at your home? Contact your city utility service branch and request registration.',
      'views.first_access.support_title': 'Laager Support',
      'views.first_access.phone_label': 'Phone',
      // Account confirmation
      'views.account_confirmation.title': 'Complete registration',
      'views.account_confirmation.invalid_title': 'Invalid link',
      'views.account_confirmation.invalid_text': 'This confirmation link is invalid or has already been used. Request a new invitation or sign in if you have already completed your registration.',
      'views.account_confirmation.go_to_login': 'Go to login',
      'views.account_confirmation.success': 'Registration completed successfully. Sign in to continue.',
      'views.account_confirmation.subtitle_with_email': 'Complete the registration of {{email}} by setting your details and a password.',
      'views.account_confirmation.subtitle_default': 'Set your details and a password to complete the registration.',
      'views.account_confirmation.submit': 'Complete registration',
      'views.account_confirmation.social.error': 'Could not start confirmation. Try again or use the form below.',
      'views.account_confirmation.social.intro': 'Confirm with one click using your Google or Facebook account — without creating a password.',
      'views.account_confirmation.social.redirecting': 'Redirecting...',
      'views.account_confirmation.social.confirm_google': 'Confirm with Google',
      'views.account_confirmation.social.confirm_facebook': 'Confirm with Facebook',
      // Landing
      'views.landing.hero_title': 'Innovation for modern challenges',
      'views.landing.hero_text': '"We are a Latin American reference in innovation and the development of solutions for energy and water efficiency using remote communication systems (IoT) for the automation of water, gas and energy meters."',
      'views.landing.hero_cta': 'Check your consumption now',
      'views.landing.section2_title': 'Innovative solutions for your everyday life',
      'views.landing.section2_text': 'Laager Tecnologias Renováveis, based in São Paulo, SP, is dedicated to transforming the way we manage water, gas and electricity resources with our innovative consumption monitoring app. Our mission is to empower individuals and companies to optimize the use of water, gas and energy, promoting sustainability and efficiency.',
      'views.landing.badge': 'Save Resources',
      'views.landing.water_title': 'Water Monitoring',
      'views.landing.water_text': 'Track your water consumption in real time and identify usage patterns.',
      'views.landing.gas_title': 'Gas Monitoring',
      'views.landing.gas_text': 'Control your gas consumption and receive alerts for atypical usage.',
      'views.landing.modal_title': 'Download the App',
      'views.landing.choose_platform': 'Choose your platform:',
      'views.landing.browser_access': 'Or access via browser:',
      'views.landing.copyright': '© 2024 Laager Tecnologias Sustentáveis. All rights reserved.',
      // Errors
      'views.errors.oops': 'Oops!',
      'views.errors.not_found': 'We could not find the requested page :(',
      'views.errors.forbidden': 'We could not find the requested page or you do not have access :(',
      'views.errors.server_error_title': 'Processing failed',
      'views.errors.server_error_text': 'An unexpected error occurred. We are sorry. We have already been notified that this problem occurred and will solve it soon.',
      'views.errors.unavailable_title': 'Service unavailable',
      'views.errors.unavailable_text': 'The readings service is currently unavailable. Please try again later',
      // Privacy policy
      'views.privacy.s1_title': '1. General Information',
      'views.privacy.s1_p1': 'This Privacy Policy contains information about how we process, fully or partially, in an automated manner or not, the personal data of users who access our site. Its purpose is to clarify for interested parties the types of data that are collected, the reasons for collection, and how the user may update, manage or delete this information.',
      'views.privacy.s1_p2': 'This Privacy Policy was drafted in compliance with Federal Law No. 12,965 of April 23, 2014 (Brazilian Civil Rights Framework for the Internet), Federal Law No. 13,709 of August 14, 2018 (Personal Data Protection Law) and EU Regulation No. 2016/679 of April 27, 2016 (General Data Protection Regulation - GDPR).',
      'views.privacy.s1_p3': 'This Privacy Policy may be updated as a result of any regulatory update, which is why the user is invited to consult this section periodically.',
      'views.privacy.s2_title': '2. User rights',
      'views.privacy.s2_intro': 'The site undertakes to comply with the rules set out in the GDPR, in respect of the following principles:',
      'views.privacy.s2_principle_1': 'The user\'s personal data will be processed lawfully, fairly and transparently (lawfulness, fairness and transparency);',
      'views.privacy.s2_principle_2': 'The user\'s personal data will be collected only for specified, explicit and legitimate purposes;',
      'views.privacy.s2_principle_3': 'The user\'s personal data will be collected in an adequate, relevant manner limited to the needs of the objective;',
      'views.privacy.s2_principle_4': 'The user\'s personal data will be accurate and updated whenever necessary;',
      'views.privacy.s2_principle_5': 'The user\'s personal data will be kept only for the necessary period;',
      'views.privacy.s2_principle_6': 'The user\'s personal data will be processed securely.',
      'views.privacy.s2_rights_intro': 'The site user has the following rights:',
      'views.privacy.s2_right_1_label': 'Right to confirmation and access:',
      'views.privacy.s2_right_1_text': 'obtain confirmation of whether or not personal data is being processed;',
      'views.privacy.s2_right_2_label': 'Right to rectification:',
      'views.privacy.s2_right_2_text': 'obtain the rectification of inaccurate personal data;',
      'views.privacy.s2_right_3_label': 'Right to erasure of data:',
      'views.privacy.s2_right_3_text': 'have your data deleted from the site;',
      'views.privacy.s2_right_4_label': 'Right to restriction of processing:',
      'views.privacy.s2_right_4_text': 'restrict the processing of your personal data;',
      'views.privacy.s2_right_5_label': 'Right to object:',
      'views.privacy.s2_right_5_text': 'object to the processing of personal data;',
      'views.privacy.s2_right_6_label': 'Right to portability:',
      'views.privacy.s2_right_6_text': 'receive personal data in a structured format;',
      'views.privacy.s2_right_7_label': 'Right not to be subject to automated decisions.',
      'views.privacy.s2_exercise': 'The user may exercise their rights through written communication sent to the e-mail:',
      'views.privacy.s3_title': '3. Duty not to provide third-party data',
      'views.privacy.s3_p1': 'While using the site, in order to safeguard and protect the rights of third parties, the site user must provide only their own personal data, and not that of third parties.',
      'views.privacy.s4_title': '4. Information collected',
      'views.privacy.s4_p1': 'The collection of user data will take place in accordance with the provisions of this Privacy Policy and will depend on the user\'s consent.',
      'views.privacy.s41_title': '4.1. Types of data collected',
      'views.privacy.s41_intro': 'The use of certain site features will depend on registration, and the following user data will be collected and stored:',
      'views.privacy.s41_data_email': 'E-mail address',
      'views.privacy.s41_data_address': 'Postal address',
      'views.privacy.s41_data_phone': 'Phone number',
      'views.privacy.s5_title': '5. Sharing of personal data',
      'views.privacy.s5_p1': 'The site does not share personal data with third parties, except when necessary for the operation of the service or required by law.',
      'views.privacy.s6_title': '6. Security',
      'views.privacy.s6_p1': 'The site undertakes to apply the technical and organizational measures capable of protecting personal data from unauthorized access and from situations of destruction, loss, alteration, communication or dissemination of such data.',
      'views.privacy.s7_title': '7. Contact',
      'views.privacy.s7_p1': 'If you have questions about this Privacy Policy or the personal data we process, please contact us:',
      // Home (missing keys)
      'views.layouts.home.messages_title': 'Important information',
      'views.layouts.home.messages_info': 'See some important messages for you.',
    }
  },
  es: {
    translation: {
      'views.layouts.home.today_consumption': 'Consumo de Hoy',
      'views.layouts.home.until_now': 'Hasta Ahora',
      'views.layouts.home.until_now_consumption': 'Consumo Hasta Ahora',
      'views.layouts.home.daily_average': 'Promedio Diario',
      'views.layouts.home.monthly_average': 'Promedio Mensual',
      'views.layouts.home.consumption_preview': 'Previsión de Consumo',
      'views.layouts.home.monthly_consumption': 'Consumo Mensual',
      'views.layouts.home.monthly_consumption_subtitle': 'Últimos meses de consumo',
      'views.layouts.home.monthly_consumption_messages': 'Mensajes sobre su consumo',
      'views.layouts.home.many_days_to_closure_prefix': 'Faltan',
      'views.layouts.home.many_days_to_closure_suffix': 'días para el cierre',
      'views.layouts.home.one_day_to_closure_prefix': 'Falta',
      'views.layouts.home.one_day_to_closure_suffix': 'día para el cierre',
      'views.layouts.home.today_closure_today': 'Hoy',
      'views.layouts.home.today_closure_suffix': 'es el día del cierre',
      'views.layouts.home.message_goal': 'para su meta definida',
      'views.layouts.home.message_period': 'para el promedio del período',
      'views.layouts.home.congratulations': '¡Felicitaciones!',
      'views.layouts.home.attention': '¡Atención!',
      'views.layouts.home.warning': '¡Cuidado!',
      'views.layouts.home.low_consumption': 'Su consumo está por debajo',
      'views.layouts.home.mid_consumption': 'Su consumo está dentro',
      'views.layouts.home.high_consumption': 'Su consumo está por encima',
      'views.layouts.breadcrumb.period_start': 'Inicio del período',
      'views.consumption.water.cold': 'Fría',
      'views.consumption.water.hot': 'Caliente',
      'views.consumption.units.liters': 'L',
      'views.general.charts.type_water': 'Agua',
      'views.general.charts.type_gas': 'Gas',
      'views.general.charts.type_energy': 'Energía',
      'views.application.greetings': 'Sea Bienvenido',
      'views.application.exit': 'Salir',
      // Registrations (Edit Profile)
      'views.devise.registrations.adjustments': 'Ajustes',
      'views.devise.registrations.title': 'Perfil del usuario',
      'views.devise.registrations.subtitle': 'Aquí puede cambiar los datos de su perfil y su contraseña.',
      'views.devise.registrations.change_profile': 'Edite los datos de su perfil',
      'views.devise.registrations.email': 'Email',
      'views.devise.registrations.name': 'Nombre',
      'views.devise.registrations.last_name': 'Apellido',
      'views.devise.registrations.cellphone': 'Teléfono',
      'views.devise.registrations.inform_password': 'Por razones de seguridad, ingrese su contraseña para confirmar el cambio',
      'views.devise.registrations.password': 'Contraseña actual',
      // Report page
      'views.consumption.report.title': 'Informes',
      // Common
      'common.error': 'Error',
      'common.success': '¡Éxito!',
      'common.retry': 'Intentar de nuevo',
      // Consumption / errors
      'views.consumption.error_loading': 'No se pudieron cargar los datos.',
      // Goal
      'views.layouts.goal.config': 'Configuración de meta',
      'views.consumption.goal.title': 'Su meta',
      'views.consumption.goal.success_title': '¡Éxito!',
      'views.consumption.goal.configuration_saved': 'Configuración guardada con éxito.',
      'views.consumption.goal.saving': 'Guardando...',
      'views.consumption.goal.message': 'Este valor es solo una proyección basada en el costo promedio por m³ de los últimos 3 meses. El valor del m³ varía según el consumo total del condominio.',
      'views.consumption.goal.message_gas': 'Este valor es solo una proyección basada en el costo promedio por m³ de los últimos 3 meses. El valor por m³ varía según el consumo total del condominio.',
      // Report details
      'views.consumption.report.details': 'Ver detalles',
      'views.consumption.report.close': 'X',
      'views.consumption.report.period': 'Período',
      'views.consumption.report.to': 'a',
      'views.consumption.report.daily_average': 'Promedio diario',
      'views.consumption.report.daily_consumption': 'Consumo diario del período actual',
      'views.consumption.report.consumption_goal': 'Consumo respecto a la meta',
      'views.consumption.report.consumption_average': 'Consumo respecto al promedio',
      'views.consumption.report.total_consumption': 'Consumo total',
      'views.consumption.report.hint': '* Días con lecturas estimadas',
      'views.consumption.report.last_readings': 'Últimas cuentas - Cálculo mensual',
      'views.consumption.report.monthly_usage_report': 'Informe de consumo de los meses anteriores',
      // Charts
      'views.general.charts.checked_days': 'Días Medidos',
      'views.general.charts.checked_months': 'Meses Medidos',
      'views.general.charts.consumption_in': 'Consumo en',
      'views.general.charts.liters': 'Litros',
      'views.general.charts.type_cold_water': 'Agua Fría',
      'views.general.charts.type_hot_water': 'Agua Caliente',
      'views.general.charts.type_mineral_water': 'Agua Mineral',
      // Common (extra)
      'common.loading': 'Cargando...',
      // Menu / general
      'views.layouts.menu.home': 'Inicio',
      'views.layouts.menu.open_menu': 'Abrir menú',
      'views.layouts.menu.close_menu': 'Cerrar menú',
      'views.general.connection_error': 'Error de conexión.',
      // Sessions
      'views.devise.sessions.invalid': 'Usuario o contraseña inválidos',
      // Empty state (no consumption data)
      'views.consumption.no_data.title': 'Sin datos de consumo',
      'views.consumption.no_data.text': 'Aún no encontramos un medidor de {{meter}} registrado para esta unidad.',
      // Admin
      'views.admin.load_error': 'Error al cargar los condominios',
      'views.admin.choose_condominium': 'Elija uno de los condominios a continuación:',
      'views.admin.no_condominium_access': 'No tiene acceso a ningún condominio. Solicite acceso al condominio deseado a través del correo electrónico',
      'views.admin.residence_users.load_error': 'Error al cargar las residencias',
      'views.admin.residence_users.save_error': 'Error al guardar el email',
      'views.admin.residence_users.title': 'Registro de residentes',
      'views.admin.residence_users.intro': 'Para registrar basta con completar el campo de email y presionar ENTER. En pocos segundos la planilla se guardará automáticamente. Tras la confirmación del residente y el registro de la contraseña, los campos de nombre y apellido estarán completos.',
      'views.admin.residence_users.th_block': 'Bloque',
      'views.admin.residence_users.th_unit': 'Unidad',
      'views.admin.residence_users.th_status': 'Estado',
      'views.admin.residence_users.click_to_edit': 'Haga clic para editar',
      'views.admin.residence_users.status_confirmed': 'Confirmado',
      'views.admin.residence_users.status_pending': 'Pendiente',
      'views.admin.residence_users.status_not_registered': 'No registrado',
      'views.admin.residence_users.none_found': 'Ninguna residencia encontrada',
      // Common (extra 2)
      'common.close': 'Cerrar',
      'common.wait': 'Espere...',
      'common.back': 'Volver',
      // Login
      'views.login.email_placeholder': 'Correo electrónico',
      'views.login.password_placeholder': 'Contraseña',
      'views.login.signing_in': 'Entrando...',
      'views.login.sign_in': 'Entrar',
      'views.login.or': 'o',
      'views.login.oauth_start_error': 'No se pudo iniciar sesión con {{provider}}.',
      'views.login.sign_in_with_facebook': 'Entrar con Facebook',
      'views.login.sign_in_with_google': 'Entrar con Google',
      'views.login.sign_in_with_apple': 'Entrar con Apple',
      'views.login.create_account': 'Crear cuenta',
      'views.login.first_access': 'Primer acceso',
      'views.login.forgot_password': '¿Olvidó su contraseña?',
      // Registration - steps meta
      'views.registration.steps.address.title': 'Cree su cuenta',
      'views.registration.steps.address.subtitle': 'Ingrese el código postal y el número de su dirección para localizar su unidad.',
      'views.registration.steps.unit.title': 'Confirme su unidad',
      'views.registration.steps.unit.subtitle': 'Seleccione su unidad o compruebe la titularidad de la conexión.',
      'views.registration.steps.user_data.title': 'Sus datos',
      'views.registration.steps.user_data.subtitle': 'Complete sus datos de acceso.',
      'views.registration.steps.document.title': 'Comprobación',
      'views.registration.steps.document.subtitle': 'Envíe un documento que compruebe su titularidad.',
      'views.registration.steps.code.title': 'Confirmación',
      'views.registration.steps.success.title': '¡Listo!',
      // Registration - indicator
      'views.registration.indicator.address': 'Dirección',
      'views.registration.indicator.unit': 'Unidad',
      'views.registration.indicator.user_data': 'Sus datos',
      'views.registration.indicator.document': 'Documento',
      'views.registration.indicator.code': 'Confirmación',
      // Registration - shared
      'views.registration.have_account': '¿Ya tiene cuenta?',
      'views.registration.progress_aria': 'Progreso del registro',
      'views.registration.sending': 'Enviando...',
      'views.registration.captcha_required': 'Confirme que no es un robot.',
      'views.registration.captcha_dev_mode': 'Verificación anti-robot en modo de desarrollo (captcha desactivado).',
      'views.registration.alert.success_title': '¡Todo listo!',
      'views.registration.alert.info_title': 'Aviso',
      // Registration - password strength
      'views.registration.password_strength.0': 'Muy débil',
      'views.registration.password_strength.1': 'Débil',
      'views.registration.password_strength.2': 'Aceptable',
      'views.registration.password_strength.3': 'Buena',
      'views.registration.password_strength.4': 'Fuerte',
      'views.registration.hide_password': 'Ocultar contraseña',
      'views.registration.show_password': 'Mostrar contraseña',
      'views.registration.strength_prefix': 'Fuerza:',
      // Registration - address step
      'views.registration.address.invalid_zip': 'Ingrese un código postal válido (8 dígitos).',
      'views.registration.address.invalid_number': 'Ingrese el número de la dirección.',
      'views.registration.address.not_found': 'No encontramos una dirección con medidor Laager para ese código postal y número. Verifique los datos.',
      'views.registration.address.lookup_error': 'No se pudo consultar la dirección. Inténtelo de nuevo.',
      'views.registration.address.zip_label': 'Código postal',
      'views.registration.address.number_label': 'Número',
      'views.registration.address.number_placeholder': 'Ej.: 123',
      'views.registration.address.submit': 'Buscar dirección',
      'views.registration.address.submitting': 'Buscando...',
      // Registration - unit step
      'views.registration.unit.address_found': 'Dirección encontrada',
      'views.registration.unit.select_tower_error': 'Seleccione la torre/bloque.',
      'views.registration.unit.select_unit_error': 'Seleccione su unidad.',
      'views.registration.unit.rgi_error': 'Ingrese el RGI de su conexión.',
      'views.registration.unit.ownership_error': 'Ingrese el código de titularidad.',
      'views.registration.unit.validate_utility_error': 'No pudimos validar el RGI y el código de titularidad informados.',
      'views.registration.unit.validate_unit_error': 'No pudimos validar la unidad seleccionada.',
      'views.registration.unit.validate_generic_error': 'No se pudo validar. Inténtelo de nuevo.',
      'views.registration.unit.tower_label': 'Torre / Bloque',
      'views.registration.unit.select_placeholder': 'Seleccione...',
      'views.registration.unit.choose_tower_first': 'Elija la torre primero',
      'views.registration.unit.rgi_placeholder': 'Número de su conexión (RGI)',
      'views.registration.unit.rgi_hint': 'Se encuentra en su factura de agua/gas.',
      'views.registration.unit.ownership_label': 'Código de titularidad',
      'views.registration.unit.ownership_placeholder': 'Código enviado por la concesionaria',
      'views.registration.unit.prove_with_document': 'Comprobar titularidad enviando un documento',
      'views.registration.unit.already_registered': 'No es posible continuar el registro de la unidad seleccionada, ya que está registrada a nombre de {{name}} ({{email}}).',
      'views.registration.unit.already_registered_no_owner': 'No es posible continuar: esta unidad ya tiene un registro activo.',
      'views.registration.unit.submit': 'Validar unidad',
      'views.registration.unit.submitting': 'Validando...',
      // Registration - user data step
      'views.registration.user_data.first_name_error': 'Ingrese su nombre.',
      'views.registration.user_data.last_name_error': 'Ingrese su apellido.',
      'views.registration.user_data.email_error': 'Ingrese un correo electrónico válido.',
      'views.registration.user_data.phone_error': 'Ingrese un celular válido con código de área.',
      'views.registration.user_data.password_error': 'La contraseña debe tener al menos 8 caracteres.',
      'views.registration.user_data.confirm_error': 'Las contraseñas no coinciden.',
      'views.registration.user_data.terms_error': 'Debe aceptar los términos para continuar.',
      'views.registration.user_data.email_taken': 'Este correo ya tiene una cuenta. Intente iniciar sesión o recuperar la contraseña.',
      'views.registration.user_data.email_already_registered': 'Este correo ya está registrado. Haga clic en “Iniciar sesión” para acceder a su cuenta. Si no recuerda su contraseña, haga clic en “Recuperar contraseña”.',
      'views.registration.user_data.submit_error': 'No se pudo completar el registro. Inténtelo de nuevo.',
      'views.registration.user_data.email_hint': 'Enviaremos el código de confirmación a este correo.',
      'views.registration.user_data.password_hint': 'Use al menos 8 caracteres, con letras y números.',
      'views.registration.user_data.terms_prefix': 'He leído y acepto la',
      'views.registration.user_data.privacy_policy': 'Política de Privacidad',
      'views.registration.user_data.terms_suffix': 'y autorizo el tratamiento de mis datos (LGPD).',
      'views.registration.user_data.submit': 'Continuar',
      // Registration - document step
      'views.registration.document.invalid_format': 'Formato inválido. Envíe JPG, PNG, WEBP o PDF.',
      'views.registration.document.too_large': 'Archivo demasiado grande. El límite es de 8 MB.',
      'views.registration.document.invalid_file': 'Archivo inválido.',
      'views.registration.document.select_error': 'Seleccione un documento para enviar.',
      'views.registration.document.upload_error': 'No se pudo enviar el documento. Inténtelo de nuevo.',
      'views.registration.document.info': 'Envíe un documento que compruebe su titularidad (ej.: factura de consumo, contrato o escritura). El análisis es automático y puede requerir aprobación de la administración.',
      'views.registration.document.select_aria': 'Seleccionar documento',
      'views.registration.document.drop_hint': 'Arrastre el archivo aquí o haga clic para seleccionar',
      'views.registration.document.file_types': 'JPG, PNG, WEBP o PDF · hasta 8 MB',
      'views.registration.document.preview_alt': 'Vista previa del documento',
      'views.registration.document.remove_aria': 'Eliminar documento',
      'views.registration.document.submit': 'Enviar documento',
      // Registration - code step
      'views.registration.code.incomplete': 'Ingrese los 6 dígitos del código.',
      'views.registration.code.confirm_error': 'No se pudo confirmar el código.',
      'views.registration.code.pending_title': '¡Código confirmado!',
      'views.registration.code.pending_text': 'Su documento está en análisis. En cuanto se apruebe la titularidad, recibirá un aviso por correo electrónico y podrá acceder a su cuenta.',
      'views.registration.code.pending_flash': 'Su documento está en análisis. Recibirá un correo electrónico en cuanto se apruebe la titularidad y podrá acceder a su cuenta.',
      'views.registration.code.understood': 'Entendido',
      'views.registration.code.intro': 'Enviamos un código de 6 dígitos a <1>{{email}}</1>. Ingréselo abajo para confirmar su cuenta.',
      'views.registration.code.group_aria': 'Código de confirmación',
      'views.registration.code.digit_aria': 'Dígito {{n}}',
      'views.registration.code.spam_hint': 'Revise también la carpeta de spam. El código expira en unos minutos.',
      'views.registration.code.submit': 'Confirmar registro',
      'views.registration.code.submitting': 'Confirmando...',
      // Registration - success step
      'views.registration.success.title': '¡Registro completado!',
      'views.registration.success.text': 'Su cuenta ha sido confirmada con éxito. Ahora ya puede acceder y seguir el consumo de su unidad.',
      'views.registration.success.access_account': 'Acceder a mi cuenta',
      // Common (back to login)
      'common.back_to_login': 'Volver al inicio de sesión',
      // Forgot password
      'views.forgot_password.success': 'Correo de recuperación de contraseña enviado con éxito.',
      'views.forgot_password.error': 'Error al enviar el correo de recuperación',
      'views.forgot_password.title': 'Olvidé mi contraseña',
      'views.forgot_password.subtitle': 'Ingrese su correo registrado para recibir el enlace de restablecimiento.',
      'views.forgot_password.email_placeholder': 'Ingrese su correo para el envío del token',
      'views.forgot_password.submit': 'Enviar',
      // First access
      'views.first_access.title': 'Primer Acceso',
      'views.first_access.lgpd_label': 'LGPD:',
      'views.first_access.lgpd_text': 'Por razones de seguridad y protección de datos, necesitamos confirmar su identidad antes de liberar el acceso. Se solicitarán documentos que comprueben su identidad y vínculo con la unidad.',
      'views.first_access.create_now': 'Crear mi cuenta ahora',
      'views.first_access.create_now_hint': 'Regístrese en pocos pasos, directamente por aquí.',
      'views.first_access.prefer_support': '¿Prefiere atención? Hable con nosotros',
      'views.first_access.condo_title': '¿Medidor con dispositivo Laager en su condominio?',
      'views.first_access.condo_text': 'Póngase en contacto con su administradora o con nuestro soporte.',
      'views.first_access.city_title': '¿Medidor con dispositivo Laager en su ciudad?',
      'views.first_access.city_text': '¿Ya tiene un producto Laager instalado en su residencia? Busque la agencia de atención del servicio de la concesionaria de su ciudad y solicite el registro.',
      'views.first_access.support_title': 'Atención Laager',
      'views.first_access.phone_label': 'Teléfono',
      // Account confirmation
      'views.account_confirmation.title': 'Completar registro',
      'views.account_confirmation.invalid_title': 'Enlace inválido',
      'views.account_confirmation.invalid_text': 'Este enlace de confirmación es inválido o ya fue utilizado. Solicite una nueva invitación o inicie sesión si ya completó su registro.',
      'views.account_confirmation.go_to_login': 'Ir al inicio de sesión',
      'views.account_confirmation.success': 'Registro completado con éxito. Inicie sesión para continuar.',
      'views.account_confirmation.subtitle_with_email': 'Finalice el registro de {{email}} definiendo sus datos y una contraseña.',
      'views.account_confirmation.subtitle_default': 'Defina sus datos y una contraseña para completar el registro.',
      'views.account_confirmation.submit': 'Completar registro',
      'views.account_confirmation.social.error': 'No se pudo iniciar la confirmación. Inténtelo de nuevo o use el formulario a continuación.',
      'views.account_confirmation.social.intro': 'Confirme con un clic usando su cuenta de Google o Facebook — sin necesidad de crear una contraseña.',
      'views.account_confirmation.social.redirecting': 'Redirigiendo...',
      'views.account_confirmation.social.confirm_google': 'Confirmar con Google',
      'views.account_confirmation.social.confirm_facebook': 'Confirmar con Facebook',
      // Landing
      'views.landing.hero_title': 'Innovación para desafíos modernos',
      'views.landing.hero_text': '"Somos referencia en América Latina en innovación y desarrollo de soluciones para eficiencia energética e hídrica con la utilización de sistemas y comunicación remota (IoT) para la automatización de medidores de agua, gas y energía."',
      'views.landing.hero_cta': 'Consulte su consumo ahora',
      'views.landing.section2_title': 'Soluciones innovadoras para su día a día',
      'views.landing.section2_text': 'Laager Tecnologias Renováveis, con sede en São Paulo, SP, se dedica a transformar la forma en que gestionamos los recursos hídricos, gaseosos y eléctricos con nuestra innovadora aplicación de monitoreo de consumo. Nuestra misión es capacitar a individuos y empresas para optimizar el uso del agua, el gas y la energía, promoviendo sostenibilidad y eficiencia.',
      'views.landing.badge': 'Ahorre Recursos',
      'views.landing.water_title': 'Monitoreo de Agua',
      'views.landing.water_text': 'Siga su consumo de agua en tiempo real e identifique patrones de uso.',
      'views.landing.gas_title': 'Monitoreo de Gas',
      'views.landing.gas_text': 'Controle su consumo de gas y reciba alertas de consumo atípico.',
      'views.landing.modal_title': 'Descargue la App',
      'views.landing.choose_platform': 'Elija su plataforma:',
      'views.landing.browser_access': 'O acceda por el navegador:',
      'views.landing.copyright': '© 2024 Laager Tecnologias Sustentáveis. Todos los derechos reservados.',
      // Errors
      'views.errors.oops': '¡Ups!',
      'views.errors.not_found': 'No pudimos localizar la página deseada :(',
      'views.errors.forbidden': 'No pudimos localizar la página deseada o usted no tiene acceso :(',
      'views.errors.server_error_title': 'Fallo al procesar',
      'views.errors.server_error_text': 'Ocurrió un error que no previmos. Disculpe. Ya fuimos notificados de que este problema ocurrió y pronto lo solucionaremos.',
      'views.errors.unavailable_title': 'Servicio no disponible',
      'views.errors.unavailable_text': 'En este momento el servicio de lecturas no está disponible. Inténtelo más tarde',
      // Privacy policy
      'views.privacy.s1_title': '1. Información General',
      'views.privacy.s1_p1': 'Esta Política de Privacidad contiene información sobre cómo tratamos, total o parcialmente, de forma automatizada o no, los datos personales de los usuarios que acceden a nuestro sitio. Su objetivo es aclarar a los interesados sobre los tipos de datos que se recopilan, los motivos de la recopilación y la forma en que el usuario podrá actualizar, gestionar o eliminar esta información.',
      'views.privacy.s1_p2': 'Esta Política de Privacidad fue elaborada de conformidad con la Ley Federal n.º 12.965 del 23 de abril de 2014 (Marco Civil de Internet), con la Ley Federal n.º 13.709 del 14 de agosto de 2018 (Ley de Protección de Datos Personales) y con el Reglamento UE n.º 2016/679 del 27 de abril de 2016 (Reglamento General Europeo de Protección de Datos Personales - RGPD).',
      'views.privacy.s1_p3': 'Esta Política de Privacidad podrá actualizarse como consecuencia de una eventual actualización normativa, razón por la cual se invita al usuario a consultar periódicamente esta sección.',
      'views.privacy.s2_title': '2. Derechos del usuario',
      'views.privacy.s2_intro': 'El sitio se compromete a cumplir las normas previstas en el RGPD, respetando los siguientes principios:',
      'views.privacy.s2_principle_1': 'Los datos personales del usuario serán procesados de forma lícita, leal y transparente (licitud, lealtad y transparencia);',
      'views.privacy.s2_principle_2': 'Los datos personales del usuario serán recopilados solo para finalidades determinadas, explícitas y legítimas;',
      'views.privacy.s2_principle_3': 'Los datos personales del usuario serán recopilados de forma adecuada, pertinente y limitada a las necesidades del objetivo;',
      'views.privacy.s2_principle_4': 'Los datos personales del usuario serán exactos y actualizados siempre que sea necesario;',
      'views.privacy.s2_principle_5': 'Los datos personales del usuario serán conservados solo durante el período necesario;',
      'views.privacy.s2_principle_6': 'Los datos personales del usuario serán tratados de forma segura.',
      'views.privacy.s2_rights_intro': 'El usuario del sitio posee los siguientes derechos:',
      'views.privacy.s2_right_1_label': 'Derecho de confirmación y acceso:',
      'views.privacy.s2_right_1_text': 'obtener confirmación de si los datos personales son o no objeto de tratamiento;',
      'views.privacy.s2_right_2_label': 'Derecho de rectificación:',
      'views.privacy.s2_right_2_text': 'obtener la rectificación de los datos personales inexactos;',
      'views.privacy.s2_right_3_label': 'Derecho a la eliminación de los datos:',
      'views.privacy.s2_right_3_text': 'tener sus datos eliminados del sitio;',
      'views.privacy.s2_right_4_label': 'Derecho a la limitación del tratamiento:',
      'views.privacy.s2_right_4_text': 'limitar el tratamiento de sus datos personales;',
      'views.privacy.s2_right_5_label': 'Derecho de oposición:',
      'views.privacy.s2_right_5_text': 'oponerse al tratamiento de los datos personales;',
      'views.privacy.s2_right_6_label': 'Derecho de portabilidad:',
      'views.privacy.s2_right_6_text': 'recibir los datos personales en formato estructurado;',
      'views.privacy.s2_right_7_label': 'Derecho a no ser sometido a decisiones automatizadas.',
      'views.privacy.s2_exercise': 'El usuario podrá ejercer sus derechos mediante comunicación escrita enviada al correo electrónico:',
      'views.privacy.s3_title': '3. Deber de no proporcionar datos de terceros',
      'views.privacy.s3_p1': 'Durante la utilización del sitio, con el fin de resguardar y proteger los derechos de terceros, el usuario del sitio deberá proporcionar solo sus datos personales, y no los de terceros.',
      'views.privacy.s4_title': '4. Información recopilada',
      'views.privacy.s4_p1': 'La recopilación de datos de los usuarios se realizará de conformidad con lo dispuesto en esta Política de Privacidad y dependerá del consentimiento del usuario.',
      'views.privacy.s41_title': '4.1. Tipos de datos recopilados',
      'views.privacy.s41_intro': 'La utilización de determinadas funcionalidades del sitio dependerá del registro, siendo que los siguientes datos del usuario serán recopilados y almacenados:',
      'views.privacy.s41_data_email': 'Dirección de correo electrónico',
      'views.privacy.s41_data_address': 'Dirección postal',
      'views.privacy.s41_data_phone': 'Número de teléfono',
      'views.privacy.s5_title': '5. Compartición de datos personales',
      'views.privacy.s5_p1': 'El sitio no comparte datos personales con terceros, excepto cuando sea necesario para el funcionamiento del servicio o exigido por ley.',
      'views.privacy.s6_title': '6. Seguridad',
      'views.privacy.s6_p1': 'El sitio se compromete a aplicar las medidas técnicas y organizativas aptas para proteger los datos personales de accesos no autorizados y de situaciones de destrucción, pérdida, alteración, comunicación o difusión de dichos datos.',
      'views.privacy.s7_title': '7. Contacto',
      'views.privacy.s7_p1': 'En caso de dudas sobre esta Política de Privacidad o sobre los datos personales que tratamos, póngase en contacto:',
      // Home (missing keys)
      'views.layouts.home.messages_title': 'Información importante',
      'views.layouts.home.messages_info': 'Vea algunos mensajes importantes para usted.',
      'views.devise.registrations.submit_profile': 'Actualizar perfil',
      'views.devise.registrations.profile_updated': 'Perfil actualizado con éxito',
      'views.devise.registrations.password_updated': 'Contraseña cambiada con éxito',
      'views.devise.registrations.update_failed': 'No se pudo actualizar',
      'views.devise.registrations.change_password': 'Cambie su contraseña',
      'views.devise.registrations.new_password': 'Nueva contraseña',
      'views.devise.registrations.confirm_password': 'Confirmar contraseña',
      'views.devise.registrations.submit_password': 'Actualizar contraseña',
      'views.devise.registrations.manage_dependent': 'Administre sus dependientes',
      'views.devise.registrations.add_dependent': 'Agregar Miembro',
      'views.devise.registrations.save_dependent': 'Guardar Miembro',
      'views.devise.registrations.exclude': 'eliminar',
      'views.devise.registrations.dependent_added': 'Miembro agregado. Recibirá un correo para confirmar el acceso.',
      'views.devise.registrations.pending_confirmation': 'Esperando confirmación',
    }
  }
};

// Recupera o idioma salvo pelo usuário (persistido no rodapé)
function getSavedLanguage(): string {
  try {
    const saved = localStorage.getItem('i18nextLng');
    if (saved && ['pt', 'en', 'es'].includes(saved)) {
      return saved;
    }
  } catch {
    // ignora indisponibilidade de localStorage
  }
  return 'pt';
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getSavedLanguage(), // idioma salvo ou padrão (pt)
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false, // React já escapa
    },
  });

export default i18n;
